import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState,useRef,useEffect } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { formatAmount, parsePreference, renderAvatar } from "../../../utils";
import { BANK_DOMICILIATION_OPTIONS, COLUMNS,
         PROPOSED_PLAN_STATUS_OPTIONS,
         SIGNING_METHOD_OPTIONS } from "./constants";
import lodash from 'lodash';
import styles from './index.module.scss';
import './index.scss';
import moment from "moment";
import { DatePicker, Input, Switch, Tooltip} from "antd";
import { toast } from "react-toastify";
import YesNoSwitch from "../../common/YesNoSwitch";
import {clientPlanStandardizationDownloadFile, getPlanStandarizationTotals, PlanStandarization,savePlanStandardization} from "../../../api/client";
import StandarizationFilters from './StandarizationFilters';
import { Link } from "react-router-dom";
import { ClipBoardIcon, IconPencil, LoadingIcon } from "../../common/Icons";
import FileIcon from "./FileIcon";
import AnimatedLoadingIcon from "../../common/Icons/AnimatedLoadingIcon";
import { Button } from "primereact/button";
import MetricCards from "./MetricCards";
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import classNames from "classnames";
import CustomSelect from "./CustomSelect/CustomSelect";

const clientTypeMappings = {
  'EXISTED': 'Existant',
  'NEW': 'Nouveau',
  'RISKY': 'Existant à risque',
  'LEAVING': 'En partance',
  'OLD': 'Sortants',
  'PILOTE': 'Pilote'
}

const globalStatusMappings = {
  'TO_START': 'À commencer',
  'PENDING': 'En attente',
  'IN_PROGRESS': 'En cours',
  'COMPLETED': 'Complété',
}

export default function StandardizationPage({
  token,
  navCommunity,
  language,
  year
}) {
  const { user } = useSelector((state) => state.auth);
  const preferences =
    user && navCommunity && user.userOrganizations.length > 0
      ? user.userOrganizations.find(
          (organization) => organization.id === navCommunity.id
        ).authorisation.preferences
      : {};
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [modifiedRows, setModifiedRows] = useState([]);
  const modifiedRowsRef = useRef(modifiedRows);
  const [clientsAttachments, setClientsAttachments] = useState([]);
  const [nbResults, setNbResults] = useState(0);
  const [metricData, setMetricData] = useState({
    acceptedProposedPlan: {
      total: 0,
      percentage: 0
    },
    signedLm: {
      total: 0,
      percentage: 0
    },
    completedClients: {
      total: 0,
      percentage: 0
    },
    plannedRdvCount: 0,
    completedRdvCount: 0
  });
  const [isSaving, setIsSaving] = useState({
    notes: false,
    rowData: false
  });
  const [data, setData] = useState([]);
  const [displayedData, setDisplayedData] = useState([]);
  const [showTextModal, setShowTextModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [fileToDownload, setFileToDownload] = useState(null);
  const [filters, setFilters] = useState({
    year: new Date().getFullYear().toString(),
    keyWord: "",
    clientGroup: [
      "Sociétés",
      "Indépendants",
      "Partenaire",
      "Particuliers",
      "Gérants",
      "Sociétés - Partenaire",
      "ASBL",
      "Indépendants petite entreprise",
      "AiSBL",
      "ASBL - Consultation",
      "Particuliers - Consultation",
      "Contact",
      "Gérant petite entreprise",
      "Indépendants - Consultation",
      "ASBL - Partenaire",
      "ASBL petite entreprise",
      "Fondation privée",
      "Sociétés petite entreprise",
    ],
    partner:
      parsePreference(preferences.financial).croissance.allowViewDataBy === 11
        ? user?.id
        : null,
    globalStatus : null,
    typeClient: null,
    billingRange:null,
    deltaVariationRange : null,
    sortBy: "REVENUE_DESC",
    pageSize: 10,
    page: 0,
  });
  const [sortData, setSortData] = useState({
    sortField: null,
    sortOrder: 1
  });

  let clientDetailsQuery = useQuery(
      ["PlanStandarization", token, navCommunity, filters, sortData],
    async () => {
      if (token) {
        setIsLoadingData(true);
        try {
          const response = await PlanStandarization(
            token,
            navCommunity.id,
            filters,
            sortData.sortField,
            sortData.sortOrder
          );
          const {
            total,
            result,
            acceptedProposedPlan,
            signedLm,
            completedClients,
            plannedRdvCount,
            completedRdvCount
          } = response.data.data;
          setData(result);
          setDisplayedData(result);
          setNbResults(total);
          setMetricData({
            acceptedProposedPlan,
            signedLm,
            completedClients,
            plannedRdvCount,
            completedRdvCount
          });
        } catch (e) {
          setData([]);
          setDisplayedData([]);
          return null;
        } finally {
          setIsLoadingData(false);
        }
      }
    }
  );

  const loadTotalValues = async () => {
    try {
      const response = await getPlanStandarizationTotals(
        token,
        navCommunity.id,
        filters,
        sortData.sortField,
        sortData.sortOrder
      );
      const {
        total,
        acceptedProposedPlan,
        signedLm,
        completedClients,
        plannedRdvCount,
        completedRdvCount
      } = response.data.data;
      setNbResults(total);
      setMetricData({
        acceptedProposedPlan,
        signedLm,
        completedClients,
        plannedRdvCount,
        completedRdvCount
      });
    } catch (e) {
      return null;
    }
  }

  const handleFileUpload = (details, files) => {
    if (files) {
      const clientId = details.client.id;
      const newFiles = Array.from(files).map(file => file.name);
      handleRowModification(details, 'lmSigned.attachments', newFiles);
      if (!clientsAttachments[clientId]) {
        setClientsAttachments(prev => [...prev, { clientId, attachments: files}]);
      } else {
        setClientsAttachments(prev => prev.map(it =>
          it.clientId === clientId ?
            { clientId, attachments: files} :
            { clientId, attachments: null }
        ));
      }
    }
  };

  async function downloadFile(filePath, fileName) {
    try {
      setFileToDownload(filePath);
      const response = await clientPlanStandardizationDownloadFile({
        token,
        filePath,
        fileName
      });

      const url = response.data.data.downloadUrl;

      if (url) {
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }

    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setFileToDownload(null);
    }
  };

  const removeAttachment = (details, fileName) => {
    const newFiles = details.lmSigned.attachments?.filter(file => file !== fileName);
    handleRowModification(details, 'lmSigned.attachments', newFiles);
  };

  const clientColumnTemplate = (details) => {
    const { name, group, type, erpId, id } = details.client;
    const { manager, partner, status } = details;

    return (
      <div className={styles.std_client_column}>
        <div>
          <Tooltip
            title={
              <div className={styles.tooltip}>
                ERP ID : {erpId}
              </div>
            }
          >
            <span className={styles.name}>
              {name ? name : `ID : ${erpId}`}
            </span>
          </Tooltip>
          <div className={styles.info}>
            GROUP : {group}
          </div>
          <div className={styles.info}>
            TYPE : {clientTypeMappings[type]}
          </div>
        </div>
        <div className={styles.actions}>
          <Link to={`/${language}/fiche-client/${id}`}>
            <Tooltip placement="topRight" title="Consulter la fiche client">
              <ClipBoardIcon
                size={18}
                className="icon"
                fill="#29394D"
              />
            </Tooltip>
          </Link>
        </div>

        <div className={styles.status_and_team}>
          <div className={classNames(
            styles.status,
            styles['hello'],
            styles['status_' + status.replace(/\s+/g, '_').toLowerCase()]
          )}>
            <span className={styles.status_circle} />
            {globalStatusMappings[status]}
          </div>

          <div className={styles.avatars}>
            {details.partner && (
              <Tooltip title={`Partner: ${partner}`}>
                {renderAvatar(null, partner, 30)}
              </Tooltip>
            )}
            {details.manager && (
              <Tooltip title={`GD: ${manager}`}>
                {renderAvatar(null, manager, 24)}
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    )
  };

  const statusColumnTemplate = (details) => {
    if (details.id === 0) return <span className={styles.status}>--</span>;

    const className = `${styles['status-tag']} ${styles[`status-tag-${details.status.replace(/\s+/g, '-').toLowerCase()}`]}`;

    return <span className={className}>{globalStatusMappings[details.status]}</span>;
  };

  const PartnerColumnTemplate = (details) => {
    if (details.id === 0) return '--';

    return (
      <div className="std-partner-name-column">
        <p>
          Partner :
          <br/>
          <b>{details.partner ? details.partner : '--'}</b>
        </p>
        <p>
          GD :
          <br/>
          <b>{details.manager ? details.manager : '--'}</b>
        </p>
      </div>
    );
  };

  const BillingTypeColumnTemplate = (details) => {
    if (details.id === 0) return '--';

    const { billingType, economicBudget, sumInvoice } = details;

    return (
      <div className={styles.std_billing_type_column}>
        {billingType && (
          <>
            <p className={styles.title}>
              {billingType}
            </p>
            <p className={styles.value_container}>
              <span className={styles.symbol}>└─</span>
              <span className={styles.value}>
                {formatAmount(economicBudget, true, 0)}
              </span>
            </p>
          </>
        )}

        <p className={styles.title}>
          Chiffre d'affaire
        </p>
        <p className={styles.value_container}>
          <span className={styles.symbol}>└─</span>
          <span className={styles.value}>
            {formatAmount(sumInvoice, true, 0)}
          </span>
        </p>
      </div>
    );
  };

  const ProposedPlanStatusColumnTemplate = (details) => {
    const { status, amount, deltaCA, deltaBudget } = details.proposedPlan;


    return (
      <div className={styles.std_proposed_plan_column}>
        <Input
          className={`input ${styles.input}`}
          value={amount}
          type="number"
          placeholder="Montant proposé"
          onChange={(e) => {
            handleRowModification(details, 'proposedPlan.amount', e.target.value);
          }}
        />
        <CustomSelect
          placeholder="Sélect."
          options={PROPOSED_PLAN_STATUS_OPTIONS}
          value={PROPOSED_PLAN_STATUS_OPTIONS.find(val => val.value === status)}
          onSelect={(newValue) => {
            handleRowModification(details, 'proposedPlan.status', newValue?.value || null);
          }}
          closeMenuOnSelect={true}
        />

        <div className={styles.delta_container}>
          {deltaBudget && (
            <>
              <p className={styles.delta_title}>
                Delta facturation
              </p>
              <p className={styles.delta_value_container}>
                <span className={styles.delta_symbol}>└─</span>
                <span className={styles.delta_value}>
                  {(deltaBudget > 0 ? '+' : '') + lodash.round(deltaBudget, 2)}%
                </span>
              </p>
            </>
          )}

          {deltaCA && (
            <>
              <p className={styles.delta_title}>
                Delta CA
              </p>
              <p className={styles.delta_value_container}>
                <span className={styles.delta_symbol}>└─</span>
                <span className={styles.delta_value}>
                  {(deltaCA > 0 ? '+' : '') + lodash.round(deltaCA, 2)}%
                </span>
              </p>
            </>
          )}
        </div>
      </div>
    );
  };

  const PlannedRdvColumnTemplate = (details) => {
    if (details.id === 0) return <span>--</span>;

    const rdvObj = details.plannedRdv;
    const rdvString = typeof rdvObj === 'object' && rdvObj !== null ? rdvObj.date : rdvObj;
    const hasValue = rdvString && typeof rdvString === 'string' && rdvString !== "x";

    let date = null;
    if (hasValue) {
      date = moment(rdvString, ["YYYY-MM-DD HH:mm:ss.SSSSSS", "YYYY-MM-DD HH:mm:ss"]);
      if (!date.isValid()) {
        date = null;
      }
    }

    return (
      <div className={styles.std_planned_rdv_column}>
        <DatePicker
          value={hasValue ? date : null}
          onChange={(date) => {
            const formatted = date ? date.format("YYYY-MM-DD HH:mm:ss") : null;
            handleRowModification(details, "plannedRdv", formatted);
          }}
          format="DD/MM/YYYY HH:mm"
          showTime={{ format: "HH:mm" }}
          className={styles.datepicker}
        />

        <div className={styles.rdv_done_container}>
          <span>Est éffectué ?</span>
          <Switch
            size="small"
            checked={details.isCompletedRdv}
            onChange={(checked) => {
               handleRowModification(details, 'isCompletedRdv', checked);
            }}
          />
        </div>
      </div>
    );
  };

  const IsCompletedRdvColumnTemplate = (details) => {
    if (details.id === 0) return (<span>--</span>);

    return (
      <div className="std-is-completed-rdv-column">
        <YesNoSwitch
          size="small"
          checked={details.isCompletedRdv}
          onChange={(checked) => {
            handleRowModification(details, 'isCompletedRdv', checked);
          }}
        />
      </div>
    )
  };

  const LmSignedColumnTemplate = (details) => {
    const clientId = details.client.id;
    const lmSignedData = details.lmSigned;
    const lmSignedStatus = lmSignedData.status;
    const lmSignedDate = lmSignedData.date ? lmSignedData.date : null;
    const attachments = lmSignedData.attachments ?? [];

    let date = null;
    if (lmSignedDate) {
      date = moment(lmSignedDate, ["YYYY-MM-DD", "YYYY-MM-DD"]);
      if (!date.isValid()) {
        date = null;
      }
    }

    if (details.id === 0) return (<span>--</span>);

    if (!lmSignedStatus) {
      return (
        <YesNoSwitch
          size="small"
          checked={lmSignedStatus}
          onChange={(checked) => {
            handleRowModification(details, 'lmSigned.status', checked);
          }}
        />
      );
    }

    return (
      <div className={styles.std_lm_signed_column}>
        <YesNoSwitch
          size="small"
          checked={lmSignedStatus}
          onChange={(checked) => {
            handleRowModification(details, 'lmSigned.status', checked);
          }}
        />
        <DatePicker
          value={date}
          onChange={(date) => {
            const formatted = date ? date.format("YYYY-MM-DD") : null;
            handleRowModification(details, "lmSigned.date", formatted);
          }}
          format="DD/MM/YYYY"
          className={styles.datepicker}
        />
        {/* <div>Attachments import here....</div> */}
        <div className={styles.attachments_container}>
          <div className={styles.attachments_header}>
            <span className={styles.attachments_count}>
              Attachments ({attachments.length})
            </span>
          </div>

          {/* Upload Area */}
          <div className={classNames(styles.upload_area, styles.default)}>
            <input
              type="file"
              multiple
              className={styles.file_input}
              onChange={(e) => handleFileUpload(details, e.target.files)}
              id={`file-upload-${clientId}`}
            />

            {attachments.length === 0 ? (
              <div className={styles.upload_prompt}>
                <div className={styles.upload_icon}>
                  <svg className={styles.upload_icon_svg} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                  </svg>
                </div>
                <div className={styles.upload_text}>
                  <span className={styles.upload_link}>
                    Cliquez pour importer
                  </span>
                </div>
              </div>
            ) : (
              <div className={styles.add_more_prompt}>
                <div className={styles.add_more_text}>
                  <span className={styles.add_more_link}>
                    Importer d'autres
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* File List */}
          {attachments.length > 0 && (
            <div className={styles.file_list}>
              {attachments.map((file, i) => (
                <div
                  key={i}
                  className={styles.file_item}
                >
                  <div className={styles.file_info}>
                    {file.path === fileToDownload ?
                    (<LoadingIcon size={16} color="rgb(148, 163, 184)" />) :
                    (<FileIcon fileName={file?.name ? file.name : file} />)}
                    <div className={styles.file_details}>
                      <div
                        className={styles.file_name}
                        title={file.name ? file.name : file}
                        onClick={() => downloadFile(file.path, file.name)}
                      >
                        {file.name ? file.name : file}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => removeAttachment(details, file)}
                    className={styles.remove_button}
                    title="Remove file"
                  >
                    <svg className={styles.remove_icon} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  };

  const SigningMethodColumnTemplate = (details) => {
    if (details.id === 0) return '--';
    const value = details.signingMethod;

    return (
      <CustomSelect
        placeholder="Sélect."
        options={SIGNING_METHOD_OPTIONS}
        value={SIGNING_METHOD_OPTIONS.find(it => it.value === value) ?? null}
        onSelect={(newValue) =>
          handleRowModification(details, 'signingMethod', newValue?.value || null)
        }
        closeMenuOnSelect={true}
      />
    );
  };

  const BankDetailsColumnTemplate = (details) => {
    if (details.id === 0) return (<span>--</span>);

    const value = details.bankDomiciliation;

    return (
      <div className="status-cell">
        <CustomSelect
          placeholder="Sélect."
          options={BANK_DOMICILIATION_OPTIONS}
          value={BANK_DOMICILIATION_OPTIONS.find(val => val.value === value) ?? null}
          onSelect={(newValue) => {
            handleRowModification(details, 'bankDomiciliation', newValue?.value || null);
          }}
          closeMenuOnSelect={true}
        />
      </div>
    )
  };

  const updatesColumnTemplate = (details) => {
    if (details.id === 0) return (<span>--</span>);

    return (
      <div className={styles.std_updates_column}>
        <div className={styles.item}>
          <p>Powerteam budget</p>
          <YesNoSwitch
            className={styles.switch}
            size="xsmall"
            checked={details.budgetUpdated.status}
            onChange={(checked) => {
              handleRowModification(details, 'budgetUpdated.status', checked);
            }}
          />
        </div>

        <hr className={styles.divider} />

        <div className={styles.item}>
          <p>CRM</p>
          <YesNoSwitch
            className={styles.switch}
            size="xsmall"
            checked={details.crmUpdated}
            onChange={(checked) => {
              handleRowModification(details, 'crmUpdated', checked);
            }}
          />
        </div>

        <hr className={styles.divider} />

        <div className={styles.item}>
          <p>Facturation</p>
          <YesNoSwitch
            className={styles.switch}
            size="xsmall"
            checked={details.billingUpdated}
            onChange={(checked) => {
              handleRowModification(details, 'billingUpdated', checked);
            }}
          />
        </div>
      </div>
    )
  };

  const NotesColumnTemplate = (details) => {
    return (
      <Tooltip title="Notes">
        <span
          className="notes-icon"
          onClick={() => handleShowTextModal(true, details)}
          style={{
            backgroundColor: details.notes && details.notes.trim() !== '' ? "#E3F9F5" : "#FFFFFF",
            borderColor: details.notes && details.notes.trim() !== '' ? "#02AF8E" : "#3C4E64",
          }}
        >
          <IconPencil
            size={15}
            fill={details.notes && details.notes.trim() !== '' ? "#02AF8E" : "#3C4E64"}
          />
        </span>
      </Tooltip>
    );
  };

  COLUMNS.forEach((col) => {
    if (col.field === 'client.name') {
      col.body = clientColumnTemplate;
    } if (col.field === 'status') {
      col.body = statusColumnTemplate;
    } else if (col.field === 'partner') {
      col.body = PartnerColumnTemplate;
    } else if (col.field === 'billingType') {
      col.body = BillingTypeColumnTemplate;
    } else if (col.field === 'proposedPlan') {
      col.body = ProposedPlanStatusColumnTemplate;
    } else if (col.field === 'plannedRdv') {
      col.body = PlannedRdvColumnTemplate;
    } else if (col.field === 'isCompletedRdv') {
      col.body = IsCompletedRdvColumnTemplate;
    } else if (col.field === 'lmSigned') {
      col.body = LmSignedColumnTemplate;
    } else if (col.field === 'signingMethod') {
      col.body = SigningMethodColumnTemplate;
    } else if (col.field === 'bankDomiciliation') {
      col.body = BankDetailsColumnTemplate;
    } else if (col.field === 'updates') {
      col.body = updatesColumnTemplate;
    } else if (col.field === 'notes') {
      col.body = NotesColumnTemplate;
    }
  });

  const handleShowTextModal = (isVisible, details) => {
    if (details) {
      setSelectedRow(details);
    } else {
      setSelectedRow(null);
    }
    setShowTextModal(isVisible);
  };

  const handleSaveModifiedRows = () => {
    setIsSaving(prevState => ({...prevState, rowData: true}));

    savePlanStandardization({
      token,
      organizationId: navCommunity.id,
      year: year,
      items: modifiedRows,
      attachments: clientsAttachments
    }).then((res) => {
      if (res.status === 200) {
        setModifiedRows([]);
        const savedData = res.data.data;
        setData(prevState => prevState.map(item => {
          const savedItem = savedData.find(it => it.client.id === item.client.id);
          return savedItem ? savedItem : item;
        }));
        loadTotalValues();
        toast.success("Les données ont été enregistrées avec succès");
      } else {
        toast.error("Une erreur est survenue lors de l'enregistrement des données");
      }
    }).catch(e => {
      toast.error("Une erreur est survenue lors de l'enregistrement des données");
      console.error("Error saving data : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, rowData: false}));
    });
  };

  useEffect(() => {
    setDisplayedData(lodash.cloneDeep(data));
  }, [data]);

  const handleSaveNotes = () => {
    setIsSaving(prevState => ({...prevState, notes: true}));
    savePlanStandardization({
      token,
      organizationId: navCommunity.id,
      year,
      items: [selectedRow]
    }).then((res) => {
      if (res.status === 200) {
        setSelectedRow(null);
        const savedData = res.data.data;
        setData(prevState => prevState.map(item => {
          const savedItem = savedData.find(it => it.client.id === item.client.id);
          return savedItem ? savedItem : item;
        }));
        toast.success("Les notes sont enregistrés avec succès.");
      } else {
        toast.error("Échec de l'enregistrement des notes. Veuillez réessayer.");
      }
    }).catch(e => {
      toast.error("Échec de l'enregistrement des notes. Veuillez réessayer.");
      console.error("Error saving notes : ", e);
    }).finally(() => {
      setIsSaving(prevState => ({...prevState, notes: false}));
    });
  };

  const handleRowModification = (rowData, modifiedPropertyName, modifiedPropertyValue) => {
    const keys = modifiedPropertyName.split('.');
    const updatedRowData = {
      ...rowData,
      [modifiedPropertyName]: modifiedPropertyValue
    };

    // Set the new value in the cloned rowData
    setValue({ ...rowData }, keys, modifiedPropertyValue);

    // Update the modifiedRows state

    setModifiedRows(prevState => {
      // Check if the row already exists in modifiedRows
      const modifiedRowIndex = prevState.findIndex(i => i.client.id === rowData.client.id);

      if (modifiedRowIndex > -1) {
        // Update existing modified row
        const updatedModifiedRows = [...prevState];
        updatedModifiedRows[modifiedRowIndex] = { ...updatedModifiedRows[modifiedRowIndex], ...updatedRowData };
        return updatedModifiedRows;
      } else {
        // Add new modified row
        return [...prevState, updatedRowData];
      }
    });

    // Update the displayedData state
    setDisplayedData(prevState =>
      prevState.map(i =>
        i.client.id === rowData.client.id ? { ...rowData, [modifiedPropertyName]: modifiedPropertyValue } : i
      )
    );
  };

  const setValue = (obj, keys, value) => {
    keys.reduce((accumulator, key, index) => {
      // If we're at the last key, set the value
      if (index === keys.length - 1) {
        accumulator[key] = value;
      } else {
        // If the key doesn't exist, create an empty object
        if (!accumulator[key]) {
          accumulator[key] = {};
        }
        return accumulator[key]; // Move to the next nested object
      }
      return accumulator;
    }, obj);
  };

  useEffect(() => {
    modifiedRowsRef.current = modifiedRows;
  }, [modifiedRows]);

  useEffect(() => {
    setFilters(prevState => ({...prevState, page: 0}));
  }, [filters.pageSize]);

  const renderMetricCards = () => {
    const formattedData = [
      {
        title: 'Forfaits validés',
        value: lodash.round(metricData.acceptedProposedPlan.percentage, 0),
        unit: '%',
        items: [
          {
            title: 'Total validés',
            value: metricData.acceptedProposedPlan.total,
          },
          {
            title: 'Total clients',
            value: nbResults,
          }
        ]
      },
      {
        title: 'LDM signées',
        value: lodash.round(metricData.signedLm.percentage, 0),
        unit: '%',
        items: [
          {
            title: 'Total signés',
            value: metricData.signedLm.total,
          },
          {
            title: 'Total clients',
            value: nbResults,
          }
        ]
      },
      {
        title: 'Nombre de RDV restants',
        value: metricData.plannedRdvCount - metricData.completedRdvCount,
        items: [
          {
            title: 'RDV planifiés',
            value: metricData.plannedRdvCount,
          },
          {
            title: 'RDV effectués',
            value: metricData.completedRdvCount,
          }
        ]
      },
      {
        title: 'Clients complétés',
        value: lodash.round(metricData.completedClients.percentage, 0),
        unit: '%',
        items: [
          {
            title: 'Total complétés',
            value: metricData.completedClients.total,
          },
          {
            title: 'Total clients',
            value: nbResults,
          }
        ]
      },
    ];
    return (
      <div className={styles.metric_cards_container}>
        <MetricCards metrics={formattedData} />
      </div>
    );
  };

  return (
    <div className="std-client-plan-container">
      <div className="filters" style={{display: "flex", gap: "8px"}}>
        <StandarizationFilters
          filterFormIsVisible={false}
          filter={filters}
          nbResults={nbResults}
          updateFilter={setFilters}
          preferences={preferences}
          displaySearchBox={false}
          displayPageSizeSelect={false}
        />
      </div>

      {clientDetailsQuery.isFetching ? (
        <div className="ripple_loading" style={{alignItems: 'center'}}>
          <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
        </div>
      ) : (
        <>
          <div>
            {renderMetricCards()}
          </div>

          <DataTable
            value={displayedData}
            lazy
            paginator
            totalRecords={nbResults}
            first={filters.page * filters.pageSize + 1}
            rows={filters.pageSize}
            onPage={(e) => {
              setFilters(prevState => ({
                ...prevState,
                page: e.page,
              }));
            }}
            rowClassName="standardization-datatable-row"
            tableClassName="standardization-datatable"
            loading={isLoadingData}
            loadingIcon={
              <div className="ripple_loading" style={{alignItems: 'center'}}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" width={80} height={80} />
              </div>
            }
            onSort={(event) => {
              const { sortField, sortOrder } = event;
              setSortData({ sortField, sortOrder });
            }}
            sortField={sortData.sortField}
            sortOrder={sortData.sortOrder}
            scrollable
            scrollHeight="1000px"
          >
            {
              COLUMNS.map(col => (
                <Column
                  className="datatable-column"
                  key={col.field}
                  field={col.field}
                  header={col.header}
                  style={{width: col.style?.width ?? '1000px'}}
                  sortable={col.sortable ?? false}
                  body={col.body ?? null}
                  alignHeader={col?.alignHeader ?? 'left'}
                  resizeable={col?.resizeable ?? false}
                  align={col?.align ?? 'center'}
                  frozen={col?.field === 'client.name'}
                  alignFrozen="left"
                />
              ))
            }
          </DataTable>
          </>
      )}

      {/* save/cancel buttons */}
      {modifiedRows.length > 0 && (
        <div className="action-buttons">
          <Button
            label="Annuler"
            severity="secondary"
            size="small"
            onClick={() => {
              setModifiedRows([]);
              setDisplayedData(lodash.cloneDeep(data));
            }}
            disabled={isSaving.rowData}
          />
          <Button
            size="small"
            label={
              isSaving.rowData ? (
                <AnimatedLoadingIcon color="#ffffff" />
              ) : 'Enregistrer'
            }
            disabled={isSaving.rowData}
            severity="success"
            onClick={handleSaveModifiedRows}
          />
        </div>
      )}

      {/* notes modal dialog */}
      {showTextModal && selectedRow && (
        <Dialog
          visible={showTextModal && selectedRow}
          onHide={() => handleShowTextModal(false)}
          className="text-modal-dialog"
          header="Notes"
          footer={
            <div>
              <Button
                size="small"
                severity="success"
                onClick={handleSaveNotes}
                disabled={isSaving.notes}
              >
                {
                  isSaving.notes ? (
                    <AnimatedLoadingIcon color="#ffffff" />
                  ):
                  'Enregistrer'
                }
              </Button>
            </div>
          }
        >
          <span className="p-float-label" style={{marginTop: '20px'}}>
            <InputTextarea
              id="notes"
              className="textarea"
              rows={5}
              value={selectedRow?.notes}
              disabled={isSaving.notes}
              onChange={(e) => {
                const value = e.target.value;
                setSelectedRow(prevState => ({...prevState, notes: value}));
              }}
            />
            <label htmlFor="notes">Notes</label>
          </span>
        </Dialog>
      )}
    </div>
  )
}
